import { SettingsLayout } from '@agentic-flow-studio/shared/components/settings/SettingsLayout';
import type { SettingsNavItem } from '@agentic-flow-studio/shared/components/settings/SettingsSidebar';
import { SlidersHorizontal } from 'lucide-react';
import { pushDriver } from '../lib/push';
import { authClient, getBetterAuthToken } from '../utils/betterAuth';

const jobPlanNavItems: SettingsNavItem[] = [
  {
    id: 'job-plan',
    label: 'Job Plan Settings',
    icon: SlidersHorizontal,
    to: 'job-plan',
    description: 'Domain vertical, AI prompt rules & scheduling presets',
  },
];

export default function SettingsPage() {
  return (
    <SettingsLayout
      productKey="job_plan"
      productLabel="Job Plan"
      pushDriver={pushDriver}
      customNavItems={jobPlanNavItems}
      getAuthToken={getBetterAuthToken}
      authClient={authClient}
      showDiagnostics={import.meta.env.DEV}
    />
  );
}
